import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Popover from '@material-ui/core/Popover';
import TextStamp from './TextStamp';
//button icons
//Edit (edit/draw) GpsFixed RadioButtonChecked
import DrawIcon from '@material-ui/icons/Edit';
//FormatColorReset (erase) GpsNotFixed RadioButtonUnchecked
import EraseIcon from '../../../icons/Eraser';
//HighlightOff OR Clear OR CancelPresentation (clear) GpsOff
import ClearIcon from '@material-ui/icons/CancelPresentation';
//InvertColors (invert) Flip
import InvertIcon from '@material-ui/icons/InvertColors';
//TextFormat or TextFields or FontDownload (text) Title
import TextIcon from '@material-ui/icons/TextFields';
//Save (save or apply)
import SaveIcon from '@material-ui/icons/Save';
//Rotate Icons
//import RotateRightIcon from '@material-ui/icons/RotateRight';
//import RotateLeftIcon from '@material-ui/icons/RotateLeft';

const gridColor = '#282c34';

const useStyles = makeStyles((theme) => ({
  canvasPixel: {
	  [theme.breakpoints.up('xs')]: {
	  	width: (props: {size : number}) => props.size, //20,
	  	height: (props: {size : number}) => props.size, //20,
	  },
	  [theme.breakpoints.down('xs')]: {
		  height: (props: {size : number}) => props.size - 5, //15,
		  width: (props: {size: number}) => props.size - 5, //15,
	  },
	  border: '1px solid '+gridColor,
  },
	
  canvas : {
	  [theme.breakpoints.up('xs')]:{
		  minWidth: (props: {maxwidth : number}) => props.maxwidth,
	  },
	  [theme.breakpoints.down('xs')]:{
		  minWidth: (props: {minwidth : number}) => props.minwidth,
	  },
	  borderSpacing: 0,
  },
  canvasToolbar : {
	  flexGrow: 1,
	  [theme.breakpoints.up('xs')]: {
		  width: (props: {maxwidth : number}) => props.maxwidth, //600,
	  },
	  [theme.breakpoints.down('xs')]: {
		  width: (props: {minwidth : number}) => props.minwidth, //450,
	  },
  },
}));

export default function Canvas(props){
//class App extends Component {
	
	const {height, width, fontSize, pixel_map, id, onSubmit, splitVertical} = props;
	const size = (width) => {
		if(width <= 32)
			return 20;
		if(width > 80)
			return 7;
		return 10;
	}
	const classes = useStyles({
		size: size(width),
		minwidth : (size(width) - 3)*width,
		maxwidth : (size(width)+1)*width
	});
	//const [background, setBackground] = React.useState('#111');
	const background = '#111';
	//const [cell, setCell] = React.useState('#ffaa00');
	const cell = '#ffaa00';
	const [mouseDown, setMouseDown] = React.useState(false);
	const [pixels, setPixels] = React.useState('');
	//const [bgpixels, setBgpixels] = React.useState([[]]);
	const [msgid, setMsgid] = React.useState(0);
	const [mode, setMode] = React.useState(1);
	const [myStamp, setMyStamp] = React.useState([[]]);
	const [textPopper, setTextPopper] = React.useState({
		open: false,
		anchor: null
	});
	//const [rotation, setRotation] = React.useState(0); 
	//const [udc, setUdc] = React.useState(0);
	const [cursor, setCursor] = React.useState([99999, 99999]);
	//const [mouseDown, setMouseDown] React.useState(false);
	React.useEffect(() => {
		//Only update from new pixel map
		//Ensure changes in-progress are preserved
	if(
		//inherited daysetting ID is null
		msgid === 0 || 
		msgid === undefined || 
		msgid === null || 
		msgid === "0" || 
		//inherited daysetting has changed
		msgid !== id 
	) {
			setMsgid(id);
			setPixels(stamp(pixel_map));
	 	}
	  	//setIntervals(utils.control.setting.extractIntervals(config.daysettings[dsid]));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	

	
	//function to zero-fill
	const allOff = () => {
		let out = [];
		//zero fill to size
		for(var h = 0; h < height; h++){
			out.push('0'.repeat(width));
		}
		return out.join(',');
	};
	

	const stamp = (stamp_map, current_map, row, col) => {
		var mymap = current_map || allOff();
		const x = col || 0;
		const y = row || 0;
		if(stamp_map){
			var stmp = stamp_map.replace(/\s/g, '').split(',').filter(i=>i);
			var mapobj = Array.from(mymap.split(',').filter(i=>i), line => line.split(''));
			stmp.forEach((cr, r) => {
				cr.split('').forEach((cc, c) => {
					if(mapobj[r+y] !== undefined && mapobj[r+y][c+x] !== undefined){
						mapobj[r+y][c+x] = cc;
					}
				});
			});
			return Array.from(mapobj, line => line.join('')).join(',');
		}
		return mymap;
	};

	//Drawing functions
  	const handleMouseDown = (row, col) => {
		if(mode === 2){
			//apply stamp
			let myMap = stamp(myStamp, pixels, row, col);
			setPixels(myMap);
			setMouseDown(false);
			setMode(1);
		} else {
			setMouseDown(true);
			handleDraw(row, col);
		}
	};
	const handleMouseUp = () => {
		setMouseDown(false);
	};
	
	//Handle mouse leave
	const handleMouseLeave = (e) => {
		setCursor([9999, 9999]);
		setMouseDown(false);
		//console.log("The mouse has left!");
	}
	//handle draw if mousedown
	const handleMouseMove = (row, col) => {
		setCursor([row, col]);
		if(mouseDown)
			handleDraw(row, col);
			
	};
	//manual draw on mouse events
	const handleDraw = (row, col) => {
		var mapobj = Array.from(pixels.split(',').filter(i=>i), (line) => line.split(''));
		mapobj[row][col] = mode;
		setPixels(Array.from(mapobj, line => line.join('')).join(','));
	};
	
	//Clear
	const handleClear = () => {
		setPixels(allOff());
	}
	
	//Invert
	const handleInvert = () => {
		//let myMap = Object.assign([], pixels);
		var mapobj = Array.from(pixels.split(','), line => line.split(''));
		var myMap = [];
		mapobj.forEach((row, r) => {
			var myRow = '';
			row.forEach((col, c) => {
				//myMap[r][c] = col ? 0 : 1;
				myRow += parseInt(col) ? '0':'1';
			});
			myMap.push(myRow);
		})
		setPixels(myMap.join(','));
	}
	
	//keyboard events
	const handleKeyPress = (event) => {
		if(event.key === 'd'){
			setMode(1);
		} else if(event.key === 'e'){
			setMode(0);
		} else if(event.key === 'i'){
			handleInvert();
		} else if(event.key === 'c'){
			handleClear();
		}
		//console.log(event);
	}
	
	//Open text popper
	const addText = (e) => {
		//setBgpixels(Object.assign([], pixels));
		//console.log('setting bgpixels addText');
		setTextPopper({
			anchor: e.currentTarget,
			open:true
		});
	}
	
	//Close text popper
	const closePop = (e) => {
		setTextPopper({
			open: false,
			anchor: null
		});
	}
	
	//Handle stamp place button click
	const handleStampPlace = (stamp_map) => {
		//setBgpixels(Object.assign([], pixels));
		setMode(2);
		setMyStamp(stamp_map);
		setMouseDown(false);
		closePop();
	}
	
	//Handle click apply
	const handleSubmit = (e) => {
		if(onSubmit){
			onSubmit(pixels);
		}
	}
	
	/* using this avoids the redraw on-demand
	//Handle drawing a row of the map
	const drawRow = (rowva, r, disabled) => {
		var row = rowva.join('').split('');
		if(disabled){
			return (
				<tr>
					{row.map((col, c) => (
						<td 
							className={classes.canvasPixel}
							style={{backgroundColor: gridColor}}
						/>
					))}
				</tr>
			);
		} else {
			return (
				<tr>
					{row.map((col, c) => (
						<td 
							className={classes.canvasPixel}
							style={{backgroundColor: ((cursor[0] == r && cursor[1] == c ? mode : parseInt(col)) ? cell : background)}}
							onMouseDown={(e) => {handleMouseDown(r, c)}}
							onMouseMove={(e) => {handleMouseMove(r, c)}}
							onTouchEnd={handleMouseUp}
						/>
					))}
				</tr>
			);
		}
	}
	*/
	
	//onTouchMove={(e) => {handleMouseDown(r, c)}}
	//Handle drawing the canvas
	const drawCanvas = () => {
		//let drawmap = Object.assign([], pixels);
		var map = [];
		var drawpix = pixels;
		if(mode === 2 ){
			map = Array.from(stamp(myStamp, drawpix, cursor[0], cursor[1]).split(','), line => line.split(''));
		} else {
			map = Array.from(drawpix.split(','), line => line.split(''));
		}
		if(splitVertical){
			var map1 = map.slice(0, height/2);
			var map2 = map.slice(height/2);
			var mid = Array(splitVertical).fill('0'.repeat(width).split(''));
			return (
				<table className={classes.canvas} tabIndex={0}
					onMouseLeave={handleMouseLeave}
					onMouseUp={handleMouseUp}
					onKeyDown={handleKeyPress}
				>
					{map1.map((row, r) => (
						<tr>
							{row.map((col, c) => (
								<td 
							 		className={classes.canvasPixel}
									style={{backgroundColor: ((cursor[0] === r && cursor[1] === c ? mode : parseInt(col)) ? cell : background)}}
									onMouseDown={(e) => {handleMouseDown(r, c)}}
									onMouseMove={(e) => {handleMouseMove(r, c)}}
									onTouchEnd={handleMouseUp}
								/>
							))}
						</tr>
					))}
					{mid.map((row, r) => (
						<tr>
							{row.map((col, c) => (
								<td 
							 		className={classes.canvasPixel}
									style={{backgroundColor: gridColor}}
								/>
							))}
						</tr>
					))}
					{map2.map((row, r) => (
						<tr>
							{row.map((col, c) => (
								<td 
							 		className={classes.canvasPixel}
									style={{backgroundColor: ((cursor[0] === r+height/2 && cursor[1] === c ? mode : parseInt(col)) ? cell : background)}}
									onMouseDown={(e) => {handleMouseDown(r+height/2, c)}}
									onMouseMove={(e) => {handleMouseMove(r+height/2, c)}}
									onTouchEnd={handleMouseUp}
								/>
							))}
						</tr>
					))}
				</table>
			);
		} else {
			return (
				<table className={classes.canvas} tabIndex={0}
					onMouseLeave={handleMouseLeave}
					onMouseUp={handleMouseUp}
					onKeyDown={handleKeyPress}
				>
					{map.map((row, r) => (
						<tr>
							{row.map((col, c) => (
								<td 
						 			className={classes.canvasPixel} 
									style={{backgroundColor: ((cursor[0] === r && cursor[1] === c ? mode : parseInt(col)) ? cell : background)}} 
									onMouseDown={(e) => {handleMouseDown(r, c)}} 
									onMouseMove={(e) => {handleMouseMove(r, c)}}
									onTouchEnd={handleMouseUp}
								/>
							))}
						</tr>
					))}
            	</table>
			);
		}
	}
    return (
      <div>
		<div>
			<div className={classes.canvasToolbar}>
			<ButtonGroup fullWidth>
				<Button 
					variant={parseInt(mode) === 1 ? "contained" : "outlined"} 
					startIcon={<DrawIcon />}
					onClick={(e) => {setMode(1)}}
				>Draw</Button>
				<Button 
					variant={parseInt(mode) === 0 ? "contained" : "outlined"}
					startIcon={<EraseIcon />}
					onClick={(e) => {setMode(0)}}
				>Erase</Button>
				<Button 
					startIcon={<ClearIcon />}
					onClick={handleClear}>Clear</Button>
				<Button	
					startIcon={<InvertIcon />}
					onClick={handleInvert}>Invert</Button>
				<Button 
					variant={parseInt(mode) === 2 ? 'contained' : 'outlined'}
					startIcon={<TextIcon />}
					onClick={addText}
				>Text</Button>
				<Button
					variant="contained"
					color="primary"
					startIcon={<SaveIcon />}
					onClick={handleSubmit}
				>Apply</Button>
			
			</ButtonGroup>
			</div>
            {drawCanvas()}
			<Popover
					id='textMaker'
					open={textPopper.open}
					anchorEl={textPopper.anchor}
					onClose={closePop}
					anchorOrigin={{
								  vertical:'bottom',
								  horizontal: 'center'
								 }}
					transformOrigin={{
									 vertical:'top',
									 horizontal:'center'
									}}
			>
				<TextStamp defaultFont={fontSize} onSubmit={handleStampPlace} />
			</Popover>
		</div>
      </div>
    );
}
